import { createTheme } from "@mui/material";

export const theme = createTheme({
    typography: {
        fontFamily: [
            'Poppins'
        ].join(','),
        button: {
            textTransform: 'none'
        }
    },
});